export default {
  // 22013: '请检查git账号正确性',
  22008: '该用户关联了多个机构，请重新设置',
};
